<template>  
    <div class="card  shadow" :class="processando ? 'overlay overlay-block' : '' ">
        <div class="card-header" v-if="titulo">
            <p class="card-title" >{{titulo}}</p>  
            <div class="card-toolbar">
                <slot name="action"></slot> 
            </div>
        </div>
        <div class="card-body" > 
            <div :class="processando ? ' overlay overlay-block rounded mt-2' : '' ">
                <slot></slot>
                <div class="overlay-layer rounded bg-dark bg-opacity-5" v-if="processando">
                    <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div> 
        </div> 
    </div> 
</template>

<script lang="ts" >
	 
    import { Options, Vue  } from "vue-class-component";   
    import { Prop } from 'vue-property-decorator'; 
    @Options({
        name: "CardRh",
        components: {   },  
    }) 
    export default class CardRh extends Vue {
          
        @Prop( ) readonly processando!: any
        @Prop( ) readonly titulo!: any  
    }
	 
</script>


<style scoped> 
    .card .card-header { 
        min-height: 60px !important; 
    }
    .card .card-body {
        padding: 1rem 1.25rem !important;
    }
    .card{
        border-radius: 14px;
    }
</style>
